import { getCookie } from '@beef/utils';
import { MessageStatus, MessageType, UserType, createHistoryMessage } from "../../../../../shared/api";
import { CAPTCHA_BLOCKED_MESSAGE_KEY, CAPTCHA_BLOCKED_TIMEOUT_KEY, CAPTCHA_MAX_RETRIES } from "../../../../../shared/config";
import { getInclinedWord } from "../../../../../shared/lib";
import { ECaptchaStage } from "../useCaptcha/types";
var getRemainingBlockMs = function getRemainingBlockMs() {
  var time = getCookie(CAPTCHA_BLOCKED_TIMEOUT_KEY);
  var currentTime = new Date().getTime();
  if (time && Number(time) > currentTime) {
    return Number(time) - currentTime;
  }
  return 0;
};
var ERROR_CAPTCHA_MESSAGE = 'Возникла ошибка. Попробуйте еще раз или повторите позднее';
var retriesVariaton = ['попытка', 'попытки', 'попыток'];
var stayedVariation = ['Осталась', 'Осталось', 'Осталось'];
var minutesVariation = ['минуту', 'минуты', 'минут'];
export var getCaptchaMessage = function getCaptchaMessage(_ref) {
  var _ref$retry = _ref.retry,
    retry = _ref$retry === void 0 ? 0 : _ref$retry,
    _ref$timeout = _ref.timeout,
    timeout = _ref$timeout === void 0 ? getRemainingBlockMs() : _ref$timeout;
  var blockedTime = Math.ceil((timeout !== null && timeout !== void 0 ? timeout : getRemainingBlockMs()) / 60000);
  var retryCount = CAPTCHA_MAX_RETRIES - retry;
  return {
    // eslint-disable-next-line max-len
    init: undefined,
    start: 'Люди не любят капчу, но роботов она вообще выводит из себя — и из этого чата',
    retry: "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0451 \u0440\u0430\u0437 \u2014 \u0432\u0432\u043E\u0434\u0438\u0442\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u0446\u0438\u0444\u0440\u044B".concat(retry > 1 ? ". ".concat(getInclinedWord(retryCount, stayedVariation), " ").concat(retryCount, " ").concat(getInclinedWord(retryCount, retriesVariaton)) : ''),
    blocked: "\u0421\u043B\u0438\u0448\u043A\u043E\u043C \u043C\u043D\u043E\u0433\u043E \u043F\u043E\u043F\u044B\u0442\u043E\u043A \u2014 \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0447\u0435\u0440\u0435\u0437 ".concat(blockedTime, " ").concat(getInclinedWord(blockedTime, minutesVariation)),
    end: 'Спасибо, всё верно. Готов вам помочь',
    captcha: ERROR_CAPTCHA_MESSAGE,
    recaptcha: 'Мы уже уверены, что вы человек, но просим ввести символы ещё раз',
    error: ERROR_CAPTCHA_MESSAGE
  };
};
export var createCaptchaMessage = function createCaptchaMessage(stage, params) {
  var isCaptcha = stage === ECaptchaStage.captcha || stage === ECaptchaStage.recaptcha;
  var messageText = getCaptchaMessage(params)[stage];
  if (!messageText) {
    return null;
  }
  return createHistoryMessage(messageText, {
    author: UserType.Bot,
    messageType: isCaptcha ? MessageType.CAPTCHA : undefined,
    status: isCaptcha ? MessageStatus.sent : MessageStatus.delivered,
    id: stage === 'blocked' ? CAPTCHA_BLOCKED_MESSAGE_KEY : undefined,
    onlyClient: true
  });
};